//Generated File 
export default class DateRangePreset{
	static readonly Last30 = `Last30`;
	static readonly Last365 = `Last365`;
	static readonly Last7 = `Last7`;
	static readonly Last90 = `Last90`;
	static readonly PreviousMonth = `PreviousMonth`;
	static readonly PreviousQuarter = `PreviousQuarter`;
	static readonly PreviousWeek = `PreviousWeek`;
	static readonly PreviousYear = `PreviousYear`;
	static readonly ThisMonth = `ThisMonth`;
	static readonly ThisQuarter = `ThisQuarter`;
	static readonly ThisWeek = `ThisWeek`;
	static readonly ThisYear = `ThisYear`;
	static readonly Today = `Today`;
	static readonly Yesterday = `Yesterday`;
}
